import { atom } from 'jotai'

/**
 * 地点マスタのインポートModalの表示状態
 */
export const isOpenSiteImportModalAtom = atom<boolean>(false)

isOpenSiteImportModalAtom.debugLabel = 'isOpenSiteImportModalAtom'
